<!--
상품상세 「구매요청 메뉴 노출설정」 (TASK-161 사이클 12 결정 39-⑦ — 총괄, 관리자 추가버튼 블록)
------------------------------------
 - 현재 상태 = ON (노출 기준일 표시) / OFF
 - 라디오 ON / OFF → 저장 (변경 없으면 저장 비활성) → PATCH /prods/{prodId}/buy-request-visibility (visible=on|off) → 새로고침
 - ON = 노출 기준일 (= 카드 「구매요청일」) = 구매요청 이력 시각, 이력 없으면 현재 시각 (결정 39-⑦ 개정) · 배송취소 상품은 서버 거부
 - OFF = 구매요청 목록 「구매요청 메뉴에서 제거」 와 같은 규칙 (구매정보 있는 상품은 서버 거부)
 - 선례 = app-prod-to-cancel (버튼 onclick="app.$refs[...].form()" → 다이얼로그)
-->
<template>
    <div uk-modal esc-close="false" bg-close="false" class="br-visibility-modal">
        <div class="uk-modal-dialog uk-modal-body">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">구매요청 메뉴 노출설정</h3>

            <div class="uk-margin br-visibility-current">
                <span class="uk-text-muted">현재 상태</span>
                <span v-if="isOn" class="br-visibility-state is-on">ON</span>
                <span v-else class="br-visibility-state is-off">OFF</span>
                <span v-if="isOn" class="uk-text-muted">노출 기준일 {{ buyReqAt }}</span>
            </div>

            <div class="uk-margin br-visibility-options">
                <label class="uk-margin-right">
                    <input class="uk-radio br-visibility-on" type="radio" value="on" v-model="inputVisible"/>
                    ON — 구매요청 메뉴에 노출 (구매요청 이력 시각으로 노출, 이력 없으면 현재 시각)
                </label>
                <br/>
                <label>
                    <input class="uk-radio br-visibility-off" type="radio" value="off" v-model="inputVisible"/>
                    OFF — 구매요청 메뉴에서 제거 (배송단계 무변경)
                </label>
            </div>

            <div class="uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-primary br-visibility-submit" type="button" :disabled="busy || ! changed" @click="submit">
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // 상품ID
            prodId: Number,

            // 현재 노출 기준일 (Y-m-d H:i, 공란 = OFF)
            buyReqAt: {
                type: String,
                default: '',
            },
        },
        data: function () {
            return {
                inputVisible: 'off',
                busy: false,
            };
        },
        computed: {
            isOn() {
                return String(this.buyReqAt || '').trim() !== '';
            },

            currentVisible() {
                return this.isOn ? 'on' : 'off';
            },

            changed() {
                return this.inputVisible !== this.currentVisible;
            },
        },
        methods: {
            // 다이얼로그 열기 (현재 상태로 초기화)
            form() {
                this.inputVisible = this.currentVisible;
                UIkit.modal(this.$el).show();
            },

            submit() {
                if (this.busy || ! this.changed) {
                    return;
                }
                this.busy = true;

                $.app.ajax.module.default({
                    type: 'patch',
                    url: '/prods/' + this.prodId + '/buy-request-visibility',
                    dataType: 'json',
                    data: {
                        _token: this.csrfToken,
                        visible: this.inputVisible,
                    },
                    success: (response) => {
                        if (response && response.msg) {
                            alert(response.msg);
                        }
                        $.app.refresh();
                    },
                    complete: () => {
                        this.busy = false;
                    },
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .br-visibility-current {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .br-visibility-state {
        display: inline-flex;
        align-items: center;
        padding: 0 9px;
        border: 1px solid;
        border-radius: 3px;
        line-height: 1.55rem;

        &.is-on {
            border-color: #1e87f0;
            color: #1565c0;
        }

        &.is-off {
            border-color: #b6bcc7;
            border-style: dashed;
            color: #8a919c;
        }
    }
</style>
